import script from "./ContactSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactSection.vue?vue&type=script&setup=true&lang=js"

import "./ContactSection.vue?vue&type=style&index=0&id=34f3d46c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f3d46c"]])

export default __exports__